export default "__VITE_ASSET__BXcKvRVM__"